import React from 'react';
import Title from '../title';
import { Grid, Pagination } from 'semantic-ui-react';
import ReadCookie from '../../functions/readcookies';
import $ from "jquery";
import Server from '../../functions/server';
import View from './view';

class Tickets extends React.Component {

  state = {
    data: [],
    userId: 0,
  }

  componentDidMount() {
    this.getTickets();
    this.menucontrols();
  }

  menucontrols() {
    let menuControl = this.props.menus;
    var x;
    let ticketeditcontrol = 'none';
    menuControl.map((z) => {
      if (z.type == 'menucontrol') {
        if (z.menu == 'tickets') {
          this.setState({ allow: '1' })
        }
      }
      if (z.type == "submenucontrol") {
        if (z.menu == 'ticketedit') {
          ticketeditcontrol = z.edit;
        }
      }
    })
    if (ticketeditcontrol == true || ticketeditcontrol == 'true') {
      ticketeditcontrol = 'show';
    }
    this.setState({
      ticketeditcontrol: ticketeditcontrol,
    })
  }

  getTickets() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    this.setState({
      load: true,
      message: 'Getting Tickets Details!!!!',
    });
    $.ajax({
      type: 'POST',
      data: { 'userId': userId },
      url: Server() + 'tickets/get.php',
      success: function(data)
      {
        try {
          let totalPages;
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            totalPages = data[i].totalPages;
          }
          totalPages = Number(totalPages);
          totalPages = totalPages / 100;
          let roundOff = Math.round( totalPages );
          if (roundOff < totalPages) {
            roundOff++;
          }
          context.setState({ data: data, userId: userId, totalPages: roundOff })
        } catch (e) {

        } finally {

        }
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  update(data) {
    this.setState({ data: data })
  }

  render() {
    return (
      <div>
        <Title title={'Tickets'} openDrawer={this.props.openDrawer}/>
        { this.state.allow == '1' ?
          (
            <div>

              <div style={{padding: '2%'}}>
                <View data={this.state.data} userId={this.state.userId}
                      ticketeditcontrol={this.state.ticketeditcontrol}
                      update={this.update.bind(this)} getTickets={this.getTickets.bind(this)} />
              </div>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Tickets;